import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';

export const licenceActiveGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);

  const userRole = localStorage.getItem("UserROle")!;
  const licenceActive = localStorage.getItem("licenceActive") === "true";

  // ✅ Super admin → accès direct
  if (userRole === "SUPER_ADMIN") {
    return of(true);
  }

  console.log("licence active", typeof licenceActive, licenceActive);

  // ❌ Licence inactive
  if (!licenceActive) {
    console.log("userRole", userRole)
    if (userRole === "INSPECTEUR_PRINCIPAL") {
      router.navigate(['/inactive/demand-licence']);
    } else {
      router.navigate(['/licence/inactive']);
    }

    return of(false);
  }

  // ✅ Licence active
  return of(true);
};
